import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { BulkEditDateValueCustomFieldModal } from "~/components/Modals/BulkEditCustomFieldModal/BulkEditDateValueCustomFieldModal";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
import { useUpdateItemsCustomFieldValue } from "~/utils/CustomFields/useUpdateItemsCustomFieldValue";
export const PrivateBulkEditDateValueCustomFieldModal = /*#__PURE__*/ memo((props)=>{
    const { currentWorkspace } = useCurrentWorkspace();
    const workspaceId = currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id;
    const { updateItemsCustomFieldValue } = useUpdateItemsCustomFieldValue();
    return /*#__PURE__*/ _jsx(BulkEditDateValueCustomFieldModal, {
        ...props,
        onSave: async (params)=>{
            await updateItemsCustomFieldValue({
                ...params,
                trackingLocation: "context-menu-bulk-edit",
                workspaceId
            });
        }
    });
});
PrivateBulkEditDateValueCustomFieldModal.displayName = "PrivateBulkEditDateValueCustomFieldModal";
